import { OptimizationFailureRateOption } from './optimization-failure-rate-option';

export class FailureRateSearchResult {
  foundFailureRates: OptimizationFailureRateOption[] = [];

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.foundFailureRates = [];
    if (data.foundFailureRates) {
      this.foundFailureRates = data.foundFailureRates.map((currentFailureRate: OptimizationFailureRateOption) => {
        const newFailureRate = new OptimizationFailureRateOption();
        newFailureRate.loadFromJson(currentFailureRate);
        return newFailureRate;
      });
    }
  }
}
